
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React, {useState, useEffect} from 'react';
import Layout from "../../components/sidebarPro";
import DropDownBooks from "../../components/stories/getReady/dropDownBooks";
import styles from "../../assets/css/getReady.module.scss";
import {getBooks, getStorySubjects, getStoryWords} from "../../api/requests";
import DropdownLesson from "../../components/stories/getReady/dropDownLessons";
import DropdownTopics from "../../components/stories/getReady/dropDownGetLevels";
import {useRouter} from "next/router";
import BackToTop from "../../components/backToTop";
import Footer from "../../components/footer/Footer";
import ErrorModal from "../../components/modals/ErrorModal";
import Head from "next/head";
import useTranslation from "next-translate/useTranslation";
import TokenError from "../../components/modals/tokenError";

const GetReady = () => {
    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';
    const router = useRouter()
    const [books, setBooks] = useState();
    const [lessons, setLessons] = useState([]);
    const [selectedLesson, setSelectedLesson] = useState({lessonId: null, name: null});
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [lessonWords, setLessonWords] = useState(null);
    const [ready, setReady] = useState(false);
    const [grade, setGrade] = useState();
    const [topics, setTopics] = useState(null);
    const [error, setError] = useState(null);
    const [show, setShow] = useState(false);
    const toggle = () => setShow(!show);
    const [show2, setShow2] = useState(false);
    const toggle2 = () => setShow2(!show2);
    const defaultSelectedBook={fa:'کتاب خود را انتخاب کنید',en:'Choose Your Book'}
    const defaultSelectedLesson={fa:'درس خود را انتخاب کنید',en:'Choose Your Lesson'}
    const defaultSelectedTopic={fa:'موضوع خود را انتخاب کنید',en:'Choose Your Topic'}



    useEffect(() => {
        setLessonWords(null);
    }, [])
    useEffect(() => {
        const token = localStorage.getItem('token')

        getBooks(1,token).then(res => {
            // console.log("books for story writing: ",res.data)
            if (Array.isArray(res.data)) {
                setBooks(res.data)
            } else {
                //todo show error when user is not valid
                console.log(res.data)
            }
            // setLoading(false)
        }).catch(err => {
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                localStorage.setItem('token', '');
                localStorage.setItem('Username', '');
                localStorage.setItem('Counter', '');
                localStorage.setItem('isLogin', '');
                localStorage.setItem('CellPhoneNum', '');
                setShow2(true);
            }
            else {
                console.log("getBooks error:", {err})
            }
        })
        getStorySubjects().then(res=>{
            // console.log("getStorySubjects res",res)
            setTopics(res.data)
        }).catch(error=>console.log("getSotrySubjects error:",{error}))
    }, [])
    useEffect(async () => {
        if (selectedLesson.LessonId){
            // console.log("inside story words useEffect",selectedLesson.LessonId)
            const token = localStorage.getItem('token');
            try {
                const res = await getStoryWords(selectedLesson.LessonId,token)
                // console.log("story words:",res.data)
                setLessonWords(res.data)
            } catch (error) {
                console.log("error", error);
            }
        }
    }, [selectedLesson])

    useEffect(() => {
        if (lessons.length > 0 && selectedLesson.LessonId && selectedTopic) {
            setReady(true)
        }else{
            setReady(false)
        }
    }, [lessons, selectedLesson, selectedTopic])

    const handleStart = () => {
        const token = localStorage.getItem('token');
        const Username = localStorage.getItem('Username');
        //check if user is verified
        if (token && Username) {
            if (!grade) {
                setError(["book", false])
                setShow(true)
            } else if (!selectedLesson.LessonId) {
                setError(["lesson", false])
                setShow(true)
            } else if (!selectedTopic) {
                setError(["topic", false])
                setShow(true)
            } else {
                router.push({
                    pathname: '/wow-stories/write',
                    query: {data: [grade.name, selectedLesson.name, selectedLesson.LessonId, selectedTopic.title, selectedTopic.id]}
                })
            }
        } else {
            setError(["login", false])
            setShow(true)
        }
    }

    // console.log('selectedTopic', selectedTopic)

    return (
        <Layout page={'getReady'}>
            <Head>
                <title>{isRTL ? 'برای نوشتن آماده شوید - دنیای واژگان' : 'Get Ready To Write - WoW kanoon'}</title>
                <link rel="icon" href="/images/logos/favicon.png"/>
            </Head>
            <TokenError show={show2} toggle={toggle2} redirect={'wow-stories/getReady'}/>
            <ErrorModal error={error} show={show} toggle={toggle} redirect={'wow-stories/getReady'}/>
            <div className={styles.container}>
                <div className={styles.wrapper}>
                    <DropDownBooks classes={{bg: styles.first, arrow: styles.firstArrowDown}}
                                   defaultSelected={defaultSelectedBook}
                                   data={books}
                                   setLessons={setLessons}
                                   setGrade={setGrade}
                                   setSelectedLesson={setSelectedLesson}
                                   setLessonWords={setLessonWords}
                                   setSelectedTopic={setSelectedTopic}
                                   setError={setError}
                                   setShow={setShow}
                                   setShow2={setShow2}
                    />
                    <DropdownLesson classes={{
                        bg: grade ? styles.second : styles.grey,
                        arrow: grade ? styles.secondArrowDown : styles.greyArrowDownLeft
                    }}
                                    defaultSelected={defaultSelectedLesson}
                                    data={lessons}
                                    selectedLesson={selectedLesson}
                                    setSelectedLesson={setSelectedLesson}
                                    setError={setError}
                                    setShow={setShow}
                                    setSelectedTopic={setSelectedTopic}
                    />
                    <div className={styles.wordsWrapper}>
                        {lessonWords &&
                        lessonWords.map(item => {
                            return (
                                <p className={styles.word}>{item.Word}</p>
                            );
                        })
                        }
                    </div>
                    <DropdownTopics
                        classes={{
                            bg: selectedLesson && selectedLesson.LessonId ? styles.third : styles.grey,
                            arrow: selectedLesson && selectedLesson.LessonId ? styles.thirdArrowDown : styles.greyArrowDownRight
                        }}
                        defaultSelected={defaultSelectedTopic}
                        setSelectedTopic={setSelectedTopic}
                        data={topics}
                        selectedTopic={selectedTopic}
                        selectedLesson={selectedLesson}
                        setError={setError}
                        setShow={setShow}
                    />
                    <button
                        className={[styles.startButton, ready ? styles.ready : styles.greyStart].join(" ")}
                        onClick={handleStart}
                    >
                        {isRTL ? 'شروع' : 'Start'}
                    </button>
                </div>

            </div>
            <div className={styles.footerWrapper}>
                <div className={styles.showOnSmallScreen}>
                    <BackToTop/>
                </div>

                <Footer/>
            </div>
        </Layout>
    );
};

export default GetReady;

    export async function getStaticProps(ctx) {
        
        
        return {
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/wow-stories/getReady',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  